import React, { useEffect, Fragment } from "react";
import GymRequestCard from "../../components/ReusableComponents/GymRequestCard/GymRequestCard";
import { accessTokenApi } from "../../services/CallApi";
import { OpenJoinStudioModal } from "../../components/UI/Modals/Modals";
import "./Studios.scss";
import { useSelector, useDispatch } from "react-redux";
import { profileActions } from "../../store";

const Studios = ({ ...props }) => {
  const { pendingGyms, approvedGyms } = useSelector(
    (state) => state.profile.profileData
  );
  const dispatch = useDispatch();
  useEffect(() => {
    accessTokenApi().then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData(res.data));
      }
    });
  }, []);

  const handleJoinStudioClick = () => {
    OpenJoinStudioModal();
  };
  return (
    <Fragment>
      <div className="Studios">
        <GymsOuterUi
          title={"LINKED STUDIO"}
          handleJoinStudioClick={handleJoinStudioClick}
          gyms={approvedGyms}
        />
        <GymsOuterUi title={"PENDING STUDIO"} gyms={pendingGyms} />
      </div>
    </Fragment>
  );
};

export default Studios;

const GymsOuterUi = ({ title, gyms, handleJoinStudioClick }) => {
  return (
    <div className="StudiosRowContainer">
      {gyms.length ? (
        <Fragment>
          <div className="studio_title">
            <p className="title">{title}</p>
            {handleJoinStudioClick ? (
              <span className="add_btn" onClick={handleJoinStudioClick}>
                ADD NEW
              </span>
            ) : null}
          </div>
          <div className="StudiosRowDiv">
            <GymRequestCard gymsArray={gyms} />
          </div>
        </Fragment>
      ) : null}
    </div>
  );
};
